<template>
  <div>
    <el-drawer
      v-if="visible"
      direction="rtl"
      append-to-body
      :size="1000"
      :title="title"
      :visible="visible"
      :before-close="() => $refs.main.cancel()"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :editImage="editImage"
          :isSingle="isSingle"
          :amzSkuCode="amzSkuCode"
          :amzSkuSpecCode="amzSkuSpecCode"
          :sku="sku"
          @close="close()"
          @reload="$emit('reload')"
        />
      </div>

      <div class="drawer-footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.main.save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    editImage: { type: Boolean, default: true },
    isSingle: { type: Boolean, default: true },
    amzSkuCode: { type: String, default: '' },
    amzSkuSpecCode: { type: String, default: '' },
    sku: { type: Object, default: () => ({}) },
  },
  computed: {
    title() {
      return this.amzSkuSpecCode
        ? this.$l('INDEX.dialog_title_editAwsSkuProductSpec') || '编辑规格信息'
        : this.$l('INDEX.dialog_title_addAwsSkuProductSpec') || '新增规格信息'
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.drawer-main {
  padding: 0 20px 10px;
}

.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
